import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-position}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "normal", "sub", "super");
//# sourceMappingURL=font-variant-position.js.map